import React, { useEffect, useState } from "react";
import { Modal } from "bootstrap";
import './NFTStepsModal.css';
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

const NftStepsModal = ({ visible, step, isError, messageList, isLoading, onClose, orderHash }) => {
    const history = useHistory()
   
    const currentUser = useSelector(state => state?.Profile?.profile?.user_name)
  
    const [animateSuccess, setAnimateSuccess] = useState(false);

    useEffect(() => {
        const modalElement = document.getElementById("StepsModal");
        const modalInstance = Modal.getOrCreateInstance(modalElement);

        if (visible) {
            modalInstance.show();
        } else {
            modalInstance.hide();
        }

        // Cleanup: detach Bootstrap events when unmounting
        return () => {
            modalInstance.hide();
        };
    }, [visible]);

    useEffect(() => {
        if (step === 4 && !isError) {
            setTimeout(() => setAnimateSuccess(true), 300);
        } else {
            setAnimateSuccess(false);
        }
    }, [step, isError]);

    const getStepIcon = (stepNum) => {
        const icons = {
            1: 'fa-save',
            2: 'fa-hammer',
            3: 'fa-shopping-cart',
            4: 'fa-check-circle'
        };
        return icons[stepNum] || 'fa-circle';
    };

    const renderStepMessage = () => {
        if (isError) {
            return (
                <div className="step-content-wrapper">
                    <div className="error-state">
                        <div className="error-icon-wrapper">
                            <i className="fas fa-exclamation-triangle"></i>
                        </div>
                        <h3 className="error-title">Operation Failed</h3>
                        <div className="error-message-box">
                            <p className="mb-0">{isError}</p>
                        </div>
                        <button
                            onClick={onClose}
                            type="button"
                            className="btn BtnBlack px-5 py-2 mt-4"
                        >
                            <i className="fas fa-redo me-2"></i>
                            Try Again
                        </button>
                    </div>
                </div>
            );
        }

        switch (step) {
            case 1:
                return (
                    <div className="step-content-wrapper">
                        <div className="step-loading-state">
                            <div className="loading-spinner-wrapper">
                                <div className="custom-spinner"></div>
                            </div>
                            <h4 className="step-title">Saving Information</h4>
                            <p className="step-description">
                                Preparing your NFT data and uploading to the network...
                            </p>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="step-content-wrapper">
                        <div className="step-loading-state">
                            <div className="loading-spinner-wrapper">
                                <div className="custom-spinner"></div>
                            </div>
                            <h4 className="step-title">Minting NFT Token</h4>
                            <p className="step-description">
                                Creating your unique NFT on the blockchain. This may take a moment...
                            </p>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="step-content-wrapper">
                        <div className="step-loading-state">
                            <div className="loading-spinner-wrapper">
                                <div className="custom-spinner"></div>
                            </div>
                            <h4 className="step-title">Creating Market Order</h4>
                            <p className="step-description">
                                Setting up your NFT listing on the marketplace...
                            </p>
                        </div>
                    </div>
                );
            case 4:
                return (
                    <div className="step-content-wrapper">
                        <div className={`success-state ${animateSuccess ? 'animate' : ''}`}>
                            <div className="success-icon-wrapper">
                                <div className="success-circle-bg"></div>
                                <i className="fas fa-check-circle success-icon"></i>
                            </div>
                            <h3 className="success-title">NFT Created Successfully!</h3>

                            {
                                !orderHash ? <p className="success-subtitle">
                                    Your NFT has been successfully minted! You can now visit your profile to list it on the marketplace.
                                </p> :
                                    <p className="success-subtitle">
                                        Your NFT has been minted and is now live on the marketplace
                                    </p>
                            }


                            {messageList?.map((item, index) => (
                                <div key={index} className="transaction-details-card">
                                    {item.title && (
                                        <div className="detail-row">
                                            <div className="detail-label">
                                                <i className="fas fa-info-circle me-2"></i>
                                                Message
                                            </div>
                                            <div className="detail-value">{item.title}</div>
                                        </div>
                                    )}

                                    {item.blockHash && (
                                        <div className="detail-row">
                                            <div className="detail-label">
                                                <i className="fas fa-cube me-2"></i>
                                                Block Hash
                                            </div>
                                            <div className="detail-value">
                                                <a
                                                    className="blockchain-link"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href={`${process.env.REACT_APP_NFT_EXPLORER}/${item.blockHash}`}
                                                >
                                                    {item.blockHash.substring(0, 16)}...{item.blockHash.substring(item.blockHash.length - 16)}
                                                    <i className="fas fa-external-link-alt ms-2"></i>
                                                </a>
                                            </div>
                                        </div>
                                    )}

                                    {item.tokenId && (
                                        <div className="detail-row">
                                            <div className="detail-label">
                                                <i className="fas fa-hashtag me-2"></i>
                                                Token ID
                                            </div>
                                            <div className="detail-value">
                                                <span className="token-id-badge">{item.tokenId}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}

                            <button
                                onClick={() => {
                                    onClose(true)
                                    history.push(`/profile/${currentUser}`);

                                }}
                                type="button"
                                className="btn BtnBlack px-5 py-2 mt-4"
                            >
                                <i className="fas fa-check me-2"></i>
                                View My NFT
                            </button>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    const steps = [
        { id: 1, label: 'Save Info', icon: 'fa-database' },
        { id: 2, label: 'Mint NFT', icon: 'fa-hammer' },
        { id: 3, label: 'Create Order', icon: 'fa-shopping-cart' },
        { id: 4, label: 'Complete', icon: 'fa-check-circle' }
    ];

    return (
        <div
            className="modal fade"
            id="StepsModal"
            tabIndex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="StepsModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div className="modal-content nft-steps-modal-content">
                    {/* Modern Header */}
                    <div className="modal-header border-0 pb-2">
                        <div className="w-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="steps-modal-icon-wrapper me-3">
                                        {isError ? (
                                            <i className="fas fa-exclamation-triangle"></i>
                                        ) : step === 4 ? (
                                            <i className="fas fa-check-circle"></i>
                                        ) : (
                                            <i className="fas fa-cog fa-spin"></i>
                                        )}
                                    </div>
                                    <div>
                                        <h5 className="modal-title mb-0">
                                            {isError ? "Error Occurred" : step === 4 ? "Success!" : "Creating Your NFT"}
                                        </h5>
                                        <p className="text-muted small mb-0">
                                            {isError ? "Something went wrong" : step === 4 ? "Your NFT is ready" : "Please wait while we process..."}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-body">
                        {/* Modern Progress Bar */}
                        {!isError && (
                            <div className="modern-progress-bar-container mb-4">
                                <div className="progress-steps-wrapper">
                                    {steps.map((s, index) => (
                                        <React.Fragment key={s.id}>
                                            <div className="progress-step-item">
                                                <div className={`progress-step-circle ${step >= s.id ? 'active' : ''
                                                    } ${step === s.id && !isError && step !== 4 ? 'current' : ''}`}>
                                                    {step > s.id ? (
                                                        <i className="fas fa-check"></i>
                                                    ) : (
                                                        <i className={`fas ${s.icon}`}></i>
                                                    )}
                                                </div>
                                                <span className={`progress-step-label ${step >= s.id ? 'active' : ''}`}>
                                                    {s.label}
                                                </span>
                                            </div>
                                            {index < steps.length - 1 && (
                                                <div className={`progress-step-line ${step > s.id ? 'active' : ''}`}></div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Step Content */}
                        <div className="steps-content-area">
                            {renderStepMessage()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NftStepsModal;
